import { Component, Vue } from "vue-property-decorator";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import gql from "graphql-tag";
import { AGENCIES_LISTING_QUERY } from "@/graphql/agencies-listing-query";
import { AGENCY_SERVICE_LIST_QUERY } from "@/graphql/agency-service-list-query";
import { AgenciesList } from "@/models/agency-listings/agency-listings.interface";
import { AgenciesServiceListsData } from "../agency-service-lists/agency-service-lists.interface";
import AgenciesDescriptionComponent from "../agency-description/agency-description.component.vue";

@Component({
  name: "agency-listing",
  components: {
    AppLoaderComponent,
    AgenciesDescriptionComponent,
  },
})
export default class AgenciesListingComponent extends Vue {
  public isLoading = true;
  public agencyList: AgenciesList[] = [];
  public limit = 9;
  public page = 1;
  public totalItem = 0;
  public searchText = "";
  public serviceLists: AgenciesServiceListsData[] = [];
  public selectedService = "";
  public selectedServiceLabel = "All services";
  public isServiceOpen = false;

  public async created() {
    await Promise.all([this.getServiceList(), this.getAgencyList()]);
  }

  public mounted() {
    document.addEventListener("click", this.onDocumentClick);
  }

  public beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
  }

  public onDocumentClick(event: MouseEvent) {
    const dropdown = this.$refs.serviceDropdown as HTMLElement;
    if (
      this.isServiceOpen &&
      dropdown &&
      !dropdown.contains(event.target as Node)
    ) {
      this.isServiceOpen = false;
    }
  }

  public toggleServiceDropdown() {
    this.isServiceOpen = !this.isServiceOpen;
  }

  public selectService(refId: string, label: string) {
    this.selectedService = refId;
    this.selectedServiceLabel = label;
    this.isServiceOpen = false;
    this.onServiceChange();
  }

  public async getServiceList() {
    await this.$apollo
      .query({
        query: gql`query ${AGENCY_SERVICE_LIST_QUERY}`,
      })
      .then((result) => {
        this.serviceLists = result.data.agencyServiceLists.data;
      });
  }

  public async getAgencyList() {
    this.isLoading = true;
    const search = this.searchText.trim();
    const hasSearch = search.length > 0;
    const hasService = this.selectedService.length > 0;

    const variableDefs: string[] = [];
    const variables: Record<string, string> = {};

    let searchFilter = "";
    if (hasSearch) {
      variableDefs.push("$search: String");
      variables.search = search;
      searchFilter = `organization_Info: { resource_name: { containsi: $search } }`;
    }

    let serviceFilter = "";
    if (hasService) {
      variableDefs.push("$service: String");
      variables.service = this.selectedService;
      serviceFilter = `services: { services: { containsi: $service } }`;
    }

    const variableBlock = variableDefs.length
      ? `(${variableDefs.join(", ")})`
      : "";

    await this.$apollo
      .query({
        query: gql`query Agency${variableBlock} {
                        agencies (filters: { status: { eq: "Approved" } ${searchFilter} ${serviceFilter} } sort: ["organization_Info.resource_name:asc"], pagination: { page: ${this.page}, pageSize: ${this.limit} }) {
                          ${AGENCIES_LISTING_QUERY}
                        }
                      }`,
        variables,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        this.totalItem = result.data.agencies.meta.pagination.total;
        this.agencyList = result.data.agencies.data;
        this.isLoading = false;
      });
  }

  public searchAgency() {
    this.page = 1;
    this.getAgencyList();
  }

  public onServiceChange() {
    this.page = 1;
    this.getAgencyList();
  }

  public clearSearch() {
    this.searchText = "";
    this.page = 1;
    this.getAgencyList();
  }

  public agencyView(agency: AgenciesList) {
    this.$router.push(`/agency/view/${agency.id}`);
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  public loadContent(page: number) {
    this.page = page;
    this.getAgencyList();
  }
}
